import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import axios from 'axios';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
Vue.use(Donut);

axios.defaults.withCredentials = true;

// axios.defaults.baseURL = 'http://localhost:5000/';  // the FastAPI backend
// axios.defaults.baseURL = 'https://silikai.digital.tecnalia.dev/';  // the FastAPI backend
axios.defaults.baseURL = 'https://silikai.silam.com/';  // the FastAPI backend

Vue.config.productionTip = false;

axios.interceptors.response.use(undefined, function (error) {
  if (error) {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      store.dispatch('logOut');
      return router.push('/login')
    } else {
      return Promise.reject(error);
    }
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
